import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "form-control" }
const _hoisted_3 = {
  key: 1,
  class: "form-control"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_localized_text, {
        localizedKey: "Form di acquisto",
        text: "Form di acquisto"
      })
    ]),
    (_ctx.hasForm)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.answers, (value, key, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "form-group",
            key: key
          }, [
            _createElementVNode("label", null, _toDisplayString(key), 1),
            _createElementVNode("span", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (item, i) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  _createTextVNode(_toDisplayString(item), 1),
                  (i < value.length - 1)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(",")
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
              }), 256))
            ])
          ]))
        }), 128))
      : (_openBlock(), _createElementBlock("span", _hoisted_3, " Nessun dato "))
  ]))
}